// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__aNHMC","content":"styles_content__1QRBz","row":"styles_row__2Wtk3","footer":"styles_footer__KEo00","phraseLength":"styles_phraseLength__uBZOq"};